import { render } from "./Persona_VacunaPers.vue?vue&type=template&id=dc5a563c&scoped=true"
import script from "./Persona_VacunaPers.vue?vue&type=script&lang=js"
export * from "./Persona_VacunaPers.vue?vue&type=script&lang=js"

import "@/assets/css/interruptor.css?vue&type=style&index=0&id=dc5a563c&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=dc5a563c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5a563c"]])

export default __exports__